<template>
  <div>
    관리자 체험 모드로 연결중입니다.
  </div>
</template>

<script>
import { fiflboxApi } from '@/utils/api';

const freeTrialAuth = {
  username: 'test@fiflbox.com',
  password: 'fifl00'
};

export default {
  name: 'FreetrialLogin',
  async mounted() {
    let loginResult;

    try {
      let { data } = await fiflboxApi.v1.postAccountsLogin(
        {},
        {
          auth: freeTrialAuth
        }
      );
      loginResult = data;
    } catch (err) {
      // return this.$router.replace("/").catch(()=>{});
    }

    let token = loginResult.token;

    this.$tokenStorage.setToken(token);

    const bearerToken = this.$tokenStorage.getBearerToken();

    fiflboxApi.default.setHeadersAuthorization(bearerToken);
    this.$router.push('/dashboard').catch(() => {});
  }
};
</script>
